module.exports = __webpack_public_path__ + "static/media/702814.3968fd40.svg";